document.addEventListener(
  "wpcf7mailsent",
  () => {
    // const employment = e.detail.inputs.find(item => item.name === 'employment').value;
    // const judgement = e.detail.inputs.find(item => item.name === 'court-judgement').value;

    if (window.fbq) {
      window.fbq("track", "Lead");
    }

    // if (!(employment === 'Unemployed')) {
    //   window.location.href = window.App.qualifiedPage;
    // } else {
    //   window.location.href = window.App.nonQualifiedPage;
    // }

    window.location.href = window.App.qualifiedPage;
  },
  false
);

$(".wpcf7").on("submit", event => {
  const button = $(event.target).find("[type=submit]");
  button.attr("disabled", true);
  button.addClass("loader");
});

$(".wpcf7").on("wpcf7submit", event => {
  const button = $(event.target).find("[type=submit]");
  button.attr("disabled", false);
  button.removeClass("loader");
});

$("section.home-form form").on("submit", e => {
  if ($(e.currentTarget).hasClass("open-modal")) {
    e.preventDefault();
    $("#formModal").modal("show");
  }
});
